import Range from '../common/utils/Range';
const min = 1;
const max = 5;
const Basic = Range(min, max).map(num => ({
    id: num,
    name: `${num}`,
    value: num,
}));
const BasicValues = Basic.map(({ value }) => value);
export const BasicByValue = Basic.reduce((hash, level) => {
    hash[level.value] = level;
    return hash;
}, {});
export default { Basic, BasicValues, BasicByValue };
